import { getScreenshotLink } from '@/api/methods/computers';
import i18n from '@/api/i18n/i18n';

const lengthRegex = /^(?=.{7,})/; // Длина минимум 7 символов
const uppercaseRegex = /(?=.*?[A-Z])/; // Наличие хотя бы одной заглавной буквы
const mailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

export function getScreenshotUrl(filepath) {
  return getScreenshotLink(this.$route.params.computer, filepath);
}

export const validatePassword = (password) => {
  let strength = 0;
  if (lengthRegex.test(password)) strength++;
  if (uppercaseRegex.test(password)) strength++;
  return strength > 1;
};

export function validateEmail(email) {
  return mailRegex.test(email) || email === '';
}

export function getTypePrint(outside) {
  if (outside === 1) {
    return i18n.t('global.duplex');
  }
  if (outside === 0 || outside === 2) {
    return i18n.t('global.simplex');
  }
  return '-';
}

export function getColored(colored) {
  if (colored === 1) {
    return i18n.t('global.color');
  }
  if (colored === 0 || colored === 2) {
    return i18n.t('global.blackAndWhite');
  }
  return '-';
}

export const getPrintValue = (value) => {
  if (!value) return value;
  return Math.round(+value * 100) / 100;
};

export const getCategoryName = (name) => {
  const isDbString = typeof name === 'string' && name.startsWith('$');
  return isDbString ? i18n.t(`db.${name}`) : name;
};
